import {useMutation, useQueryClient} from "react-query";
import Alert from "react-s-alert";

import {http} from "../../../services/api/restApiClient";
import {PccFacilityMappingModel} from "../../../utils/types/facility";

type Params = {
  facilityId: string;
  pccFacilityMapping: PccFacilityMappingModel;
};

export const usePccFacilityMappingMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: Params) =>
      http.put(`/facilities/${params.facilityId}/pcc-mapping`, params.pccFacilityMapping),
    {
      onSuccess: (_data, {facilityId}) => {
        queryClient.invalidateQueries(["getPccFacilityMapping", facilityId]);
        Alert.success("PointClickCare mapping updated.");
      },
      onError: (error: any) => {
        const errorMessage = error.data?.detail || error.data?.message ||
          "An error occurred while updating PointClickCare connection data";
        Alert.error(errorMessage);
      },
    },
  );
};
